import type { User } from '@core/entities/User';
import type { AuthRepository, TwoFactorChallengePayload } from '@core/repositories/AuthRepository';

export class ChallengeTwoFactorUseCase {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  execute(payload: TwoFactorChallengePayload): Promise<User> {
    return this.authRepository.challengeTwoFactor(payload);
  }
}
